import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';

import FeedbackController from './FeedbackController';

import panel from '../../services';

export default angular.module('app.feedback', [uirouter, panel])
    .config(routing)
    .controller('FeedbackController', FeedbackController)
    .name;


// WEBPACK FOOTER //
// ./src/app/features/feedback/index.js